import MyPayroll from "../../employee/myPayroll/myPayroll";

function MyPayrollOverview() {
    return (
        <MyPayroll />
    )
}

export default MyPayrollOverview;